import dior from "./dior.svg";
import chanel from "@JohnLewisPartnership/jl-design-system/dist/assets/third-party/partner-brands/chanel.svg";
import styles from "./BrandBanner.module.scss";
import { Breadcrumb } from "@/types/productListing";
import { StandardProps } from "@/types/types";

type BannerDetails = {
  bannerHref: string;
  bannerImage: string;
  bannerAlt: string;
  bannerStyles?: string;
};

const getBrandBanner = (crumbs: Breadcrumb[]): BannerDetails | null => {
  const section = crumbs[0]?.displayName;
  const brand = crumbs[1]?.displayName.toLowerCase();

  if (!crumbs || crumbs.length < 2) return null;

  if (section === "Beauty" && brand === "chanel") {
    return {
      bannerHref: "/beauty/chanel/c7000370531",
      bannerImage: chanel,
      bannerAlt: "CHANEL",
      bannerStyles: [styles.banner, styles.chanel].join(" "),
    };
  }

  if (["Shop by Brand", "Beauty"].includes(section || "") && brand === "dior") {
    return {
      bannerHref: "/beauty/dior/c600002684",
      bannerImage: dior,
      bannerAlt: "DIOR",
      bannerStyles: styles.banner,
    };
  }

  return null;
};

export function BrandBanner({
  productListingData,
}: Pick<StandardProps, "productListingData">) {
  const bannerDetails = getBrandBanner(productListingData.crumbs);
  if (!bannerDetails) return null;

  const { bannerHref, bannerImage, bannerAlt, bannerStyles } = bannerDetails;

  return (
    <aside
      aria-label="Brand Banner"
      data-testid="brand-banner-container"
      className={styles.container}
    >
      {bannerDetails.bannerAlt === "CHANEL" && (
        <div className={styles.chanelStripe} />
      )}
      <a className={bannerStyles} href={bannerHref}>
        <img src={bannerImage} alt={bannerAlt} loading="lazy" />
      </a>
    </aside>
  );
}
